import { AlgoliaSearchClient } from "./algolia/algolia-search-client";
import SearchClient from "./search-client";
import { SearchSpringSearchClient } from "./searchspring/searchspring-search-client";
import {
	AlgoliaSearchClientConfig,
	SearchClientConfig,
	SearchSpringClientConfig,
} from "./types";

// Conditional return type based on config type
type SearchClientReturnType<T extends SearchClientConfig> =
	T extends AlgoliaSearchClientConfig ? AlgoliaSearchClient : SearchClient;

// Function overloads for type inference based on config.type
export function createSearchClient<T extends AlgoliaSearchClientConfig>(
	config: T,
): AlgoliaSearchClient;
export function createSearchClient<T extends SearchSpringClientConfig>(
	config: T,
): SearchClient;
export function createSearchClient<T extends SearchClientConfig>(
	config: T,
): SearchClientReturnType<T>;
export function createSearchClient(
	config: SearchClientConfig,
): AlgoliaSearchClient | SearchClient {
	switch (config.type) {
		case "algolia":
			return new AlgoliaSearchClient(config);
		case "searchspring":
			return new SearchSpringSearchClient(config);
		default:
			throw new Error(`Unsupported search client type`);
	}
}
